<template>
  <div class="md-layout">
    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
      <div class="md-layout">
        <div class="md-layout-item md-size-20 md-small-hide page-container-side text-right">
          <div><h2>{{$t('confirmation')}}</h2></div>
        </div>
        <div class="md-layout-item md-size-80 md-small-size-100">
          <div class="page-container-section">
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <div><h2 class="page-sub-title">{{$t('rma-confirmation')}}</h2></div>
              </div>              
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-100" v-if="rmaDetail">
                <request-steppers :detail="rmaDetail" />
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-100">
                <p class="text-right">
                  <md-button to="/">{{$t('back-to-home')}}</md-button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item">
          <md-snackbar :md-active.sync="showErrorMsg" :md-duration="8000">{{$t('encountered-error')}}</md-snackbar>
        </div>
      </div>
      <full-page-loading :show="fullPageLoading" :error="showErrorMsg" />
    </div>
  </div>
</template>

<script>
  import RequestSteppers from '../components/RequestSteppers'
  import FullPageLoading from '../components/FullPageLoading'
  import Auth from '../mixins/auth'
  import { mapMutations,mapState,mapActions } from 'vuex'
  import * as types from '../store/mutation-types'
  import { apiServer,i18n } from '../config'  
  import { languageCode, getStoreCodeByUrl, storeList } from '../mixins/store'
  
  export default {
    name: 'Confirmation',
    components: {
      RequestSteppers,
      FullPageLoading
    },
    computed: {
      ...mapState({
        store: 'store'
      })
    },
    data: () => ({
      loading: false,
      fullPageLoading: true,
      rmaNo: '',
      rmaReceivedDate: '',
      rmaDetail: null,
      request: null,
      showErrorMsg: false
    }),
    async created() {
      
      // set up language
      let code = getStoreCodeByUrl(location.href)
      if (!code || code.length == 0) code = localStorage.rma_store
      if(code && storeList.indexOf(code) >= 0) this.changeStore(code)
      i18n.locale = languageCode[this.store] ? languageCode[this.store] : 'en'
      this.updatePageTitle(this.$t('page-title'))
      this.updatePageLang(i18n.locale)
      
      this.loading = true
      this.showPageLoading()
      const r = await this.$http.request({ url: `${apiServer}/api/confirmation?store=${localStorage.rma_store}&rmaNo=${localStorage.rma_rmaNo}&rmaId=${localStorage.rma_rmaId}`, method: 'get', headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).catch(() => {
        this.loading = false
        this.hidePageLoading()
        this.showErrorMsg = true
      })
      if (r && r.status == 200) {
        this.fullPageLoading = false
        if (r.data && r.data.request) {
          this.request = r.data.request
          this.rmaNo = r.data.request.rmaNo
          this.rmaReceivedDate = r.data.request.rmaReceivedDateFormat
          localStorage.rma_step = 0
          localStorage.rma_step2_enquiry = ''
        }
        if (r.data && r.data.detail) {
          this.rmaDetail = r.data.detail
        }
        this.hidePageLoading()
        this.loading = false
      }
      else {
        this.hidePageLoading()
        this.loading = false
        this.showErrorMsg = true
      }
      this.$scrollTo('#app')
    },
    methods: {
      ...mapMutations({
        changeStore: types.CHANGE_STORE,
        showPageLoading: types.SHOW_LOADING,
        hidePageLoading: types.HIDE_LOADING
      }),      
      ...mapActions({
        updatePageTitle: types.SET_PAGE_TITLE,
        updatePageLang: types.SET_PAGE_LANG
      }),
      refresh() {
        location.reload()
        return
      }
    }
  }
</script>


<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";
</style>